import React, { PropsWithChildren } from 'react';
import useRehydrationStatus from 'src/hooks/useRehydrationStatus';

const ClientSideRender: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const status = useRehydrationStatus();
  return <>{status === 'complete' && children}</>;
};

export default ClientSideRender;
